import React, { useContext } from "react";
import { Menu, MenuButton, MenuItem, MenuList } from "@chakra-ui/react";
import styled from "styled-components/macro";
import { IconGeneric, IconMenuRUD } from "styled/Icons.styled";
import { MdDelete, MdRemoveRedEye } from "react-icons/md";
import { RiEdit2Fill } from "react-icons/ri";
import { HiDotsHorizontal } from "react-icons/hi";
import { HrDividerNoMargin } from "styled/Line.styled";
import GestionCrudContext from "context/GestionCrudContext";

const MenuItemStyled = styled(MenuItem)`
  background-color: #fff !important;
  color: #000000;

  &:hover {
    background-color: #1f7ac3 !important;
    color: #fff !important;
  }
  &:hover * {
    color: #fff !important;
  }
`;

const MenuGestionUser = ({ data, deleteField = true, licenses = false }) => {
  const {
    onOpenEdit,
    setDataToEdit,
    onOpenDelete,
    setDataToDelete,
    onOpenShow,
    setDataToShow
  } = useContext(GestionCrudContext);

  const handleEdit = (e) => {
    setDataToEdit(data);
    onOpenEdit();
  };

  const handleDelete = (e) => {
    setDataToDelete(data);
    onOpenDelete();
  };

  const handleShow = (e) => {
    setDataToShow(data);
    onOpenShow();
  };

  return (
    <Menu>
      <MenuButton>
        <IconGeneric as={HiDotsHorizontal} color="#00000085" />
      </MenuButton>

      <MenuList borderRadius="none" py={0} style={{ boxSizing: "border-box" }}>
        <MenuItemStyled py={3} onClick={handleShow}>
          <IconMenuRUD as={MdRemoveRedEye} />
          Ver
        </MenuItemStyled>

        <HrDividerNoMargin />

        <MenuItemStyled py={3} onClick={handleEdit}>
          <IconMenuRUD as={RiEdit2Fill} />
          Editar
        </MenuItemStyled>

        <HrDividerNoMargin />
        {deleteField && (
          <MenuItemStyled py={3} onClick={handleDelete}>
            <IconMenuRUD as={MdDelete} />
            Eliminar
          </MenuItemStyled>
        )}

        <HrDividerNoMargin />
      </MenuList>
    </Menu>
  );
};

export default MenuGestionUser;
